<template>
    <div class="right_flaot">
        <div class="ul-list">
            <div class="li-item" @click="toMyCourse">
                <div class="icon"></div>
                <div class="txt">我的课程</div>
            </div>
            <div class="li-item" @click="toMyCertificate">
                <div class="icon"></div>
                <div class="txt">我的证书</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {}
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo
        },
        categoryList() {
            return this.$store.state.categoryList
        },
        env() {
            return this.$store.state.env
        }
    },
    created() {},
    mounted() {},
    methods: {
        toMyCourse() {
            window.location.href = '/myCourse'
        },
        toMyCertificate() {
            window.location.href = '/myCertificate'
        }
    }
}
</script>
<style scoped lang="scss">
$s1024: 1;
$s750: 1.4;
.right_flaot {
    width: 0.84rem;
    position: fixed;
    right: 0.4rem;
    bottom: 3rem;
    z-index: 10;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
    border-radius: 0.5rem;
    padding: 0.25rem 0;
    .ul-list {
        display: flex;
        flex-direction: column;
        width: 0.66rem;
        margin: 0 auto;
        .li-item {
            flex-direction: column;
            justify-content: center;
            align-content: center;
            align-items: center;
            cursor: pointer;
            padding: 0.15rem 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            &:last-child {
                border-bottom: none;
            }
            .icon {
                width: 0.32rem;
                height: 0.25rem;
                background: url(../assets/icon_kc.png) no-repeat center center;
                background-size: contain;
                margin: 0 auto 0.1rem auto;
                &.icon1 {
                    background: url(../assets/icon_zs.png) no-repeat center center;
                    background-size: contain;
                }
            }
            .txt {
                font-size: 0.15rem;
                color: #6b7280;
                text-align: center;
            }
        }
    }
}
</style>
